const GENERIC_PROMPTS = ['Say hi!'];

const POST_PROMPTS = [
    ...GENERIC_PROMPTS,
    'Introduce yourself to prospective care providers!',
    "Let the Tandem network know what you're looking for!",
    'Describe your needs to care providers!',
    'Start your care search by introducing yourself!',
    'Last minute care need? Let our network know.',
    'Your care search starts here.',
    'Introduce yourself.',
    'Ask families for their provider recommendations.',
];

const PROVIDER_POST_COMMENT_PROMPTS = [
    ...GENERIC_PROMPTS,
    "Let this provider know you're interested in their services!",
    'Encourage this provider to apply to your job.',
    'Let this provider know you like their profile.',
    'Invite this provider to check out your family profile.',
];

const FAMILY_POST_COMMENT_PROMPTS = [
    ...GENERIC_PROMPTS,
    'Recommend a provider to this family!',
    'Share your Tandem experience and tips with this family.',
    'Ask this family for their tips and recommendations.',
];

const SELF_POST_COMMENT_PROMPTS = ['Provide an update on your post.'];

const GROUP_POST_PROMPTS = [
    'Create a private post to your group.',
    'Ask for recommendations from the group.',
    'Recommend a provider to your group.',
];

function getRandomPrompt(prompts: string[]) {
    const max = prompts.length;
    return prompts[Math.floor(Math.random() * max)];
}

function getGenericPrompt() {
    return getRandomPrompt(GENERIC_PROMPTS);
}

function getRandomFamilyPostCommentPrompt(isSelf: boolean) {
    return isSelf ? getRandomPrompt(SELF_POST_COMMENT_PROMPTS) : getRandomPrompt(FAMILY_POST_COMMENT_PROMPTS);
}

function getRandomProviderPostCommentPrompt() {
    return getRandomPrompt(PROVIDER_POST_COMMENT_PROMPTS);
}

export function getRandomCommentPrompt(isSelf: boolean, posterRole: string) {
    if (posterRole === 'FAMILY') {
        return getRandomFamilyPostCommentPrompt(isSelf);
    } else if (posterRole === 'PROVIDER') {
        return getRandomProviderPostCommentPrompt();
    }
    return getGenericPrompt();
}

export function getRandomPostPrompt(group?: boolean) {
    return getRandomPrompt(group ? GROUP_POST_PROMPTS : POST_PROMPTS);
}
